import axios from "axios";

const REQUEST_TIMEOUT = 30000;

const api = axios.create({
  baseURL: process.env.VUE_APP_BASE_API_URL,
  timeout: REQUEST_TIMEOUT,
});

export const enviarRegistro = (formData) => {
  return api.post("/registro", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};
